import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/7.png'


const _withScopeId = n => (_pushScopeId("data-v-412f9971"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-404" }
const _hoisted_2 = { class: "not-found-page" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "404"
  })
], -1))
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "您访问的页面还在建设中...", -1))
const _hoisted_6 = { class: "links" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("返回首页")

import LayoutHeader from '../../components/layout/Header.vue'
import LayoutSidebar from '../../components/layout/Sidebar.vue'
import LayoutMain from '../../components/layout/Main.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LayoutHeader),
    _createVNode(LayoutSidebar),
    _createVNode(LayoutMain, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                href: "/",
                class: "btn btn-primary router-link-active"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})